import { CheckOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PowerzapNotice from './PowerzapNotice';

export default function DoneScreen({ onFinish, onConfigureChannels }) {
	return (
		<div className="done-screen">
			<span className="done-check" aria-hidden="true">
				<CheckOutlined />
			</span>
			<header className="onboarding-screen-header">
				<h1>
					<FormattedMessage id="final_title" />
				</h1>
				<p>
					<FormattedMessage id="final_subtitle" />
				</p>
			</header>
			<PowerzapNotice />
			<div className="done-actions">
				<Button size="large" onClick={onConfigureChannels}>
					<FormattedMessage id="final_cta_bitrix" />
				</Button>
				<Button size="large" type="primary" onClick={onFinish}>
					<FormattedMessage id="final_cta_chat" />
				</Button>
			</div>
		</div>
	);
}
